import { render, staticRenderFns } from "./Senior_Editor.vue?vue&type=template&id=d76e6b1a&scoped=true"
import script from "./Senior_Editor.vue?vue&type=script&lang=js"
export * from "./Senior_Editor.vue?vue&type=script&lang=js"
import style0 from "./Senior_Editor.vue?vue&type=style&index=0&id=d76e6b1a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76e6b1a",
  null
  
)

export default component.exports